import { AppUtils } from './app.utils';
import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy, ChangeDetectorRef} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from './app.service';
import { SharedService } from './shared/shared.service';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { PermissionService } from './../app/shared/permissions/permissions.service';
import { UserProfileService } from '././user-profile/user-profile.service';
import { SideNavigationService } from '../app/shared/side-navigation/side-navigation.service';
import { BaseUtils } from './shared/core/baseUtils.service';
@Component({
  selector: 'ba-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  userName: string;
  switchUserData: any;
  clientInfo: any;
  profileSubscription: Subscription;
  isSwitchUser: any = false;
  switchUserSubscription: any;
  permissions: Array<any> = [];

  constructor(
    public translate: TranslateService,
    public appService: AppService,
    public sharedService: SharedService,
    public router: Router,
    public appUtils: AppUtils,
    public permissionService: PermissionService,
    public userProfileService: UserProfileService,
    public sidenavService: SideNavigationService,
    public baseUtils: BaseUtils,
    private cdRef: ChangeDetectorRef
  ) {
    this.switchUserSubscription = this.appService.switchUser$.subscribe((data) => {
      this.isSwitchUser = data;
    });
    this.translate.setDefaultLang('en');
    const selectedLanguage = localStorage.getItem('selectedLanguage');
    if (selectedLanguage) {
      this.translate.use(selectedLanguage);
    } else {
      this.translate.use('en');
    }
  }

  ngOnInit() {
    const user: any = JSON.parse(localStorage.getItem('loggedInUser'));
    const isFirstTimeGetCurrentRoute: any = JSON.parse(localStorage.getItem('isFirstTimeGetCurrentRoute') || 'true');
    const currentRouteUrl = localStorage.getItem('currentRouteUrl');
    if (this.router.url === '/' && currentRouteUrl !== null) {
      this.router.navigate([currentRouteUrl]);
    }
    if (user && !(user['isSwitchBackVisible'])) {
      if (currentRouteUrl) {
        this.router.navigate([currentRouteUrl]);
      } else if (isFirstTimeGetCurrentRoute) {
        this.getCurrentRoute(user);
      }
    }
    if (user && user.isSwitchBackVisible) {
      this.isSwitchUser = true;
    }
    this.profileSubscription = this.appService.updatedUserData$.subscribe((data) => {
      this.userName = data?.username || '';
      this.cdRef.detectChanges();
    });
    this.clientInfo = {
      version: environment.version,
      buildTimestamp: environment.buildTimestamp ? environment.buildTimestamp * 1000 : null,
      shortCommitId: environment.shortCommitId,
      commitId: environment.commitId,
      commitTime: environment.commitTime ? environment.commitTime * 1000 : null
    };
  }

  /*
      Function to manipulate ( add and remove ) localStorage items when we switch back to the main user
  */
  clearLocalStorageData() {
    const keysToRemove = [
      'locationResponseData',
      'selectedLocationId',
      'selectedLocationIdOverview',
      'selectedLocationIdStoreOverview',
      'selectedLocationIdTerminal',
      'selectedLocationIdDepartment',
      'selectedLocationIdStoreDepartment',
      'selectedLocationIdItems',
      'selectedLocationIdTender',
      'selectedLocationIdStoreTender',
      'selectedLocationIdSummary',
      'selectedLocationIdCashiers',
      'selectedLocationIdTransaction',
      'selectedLocationIdAnalytics',
      'salesFilter',
      'selectedMenuItem',
      'levelsFilter',
      'reportTabData',
      'itemDepartmentLocId',
      'departmentLocId',
      'reportListTabData',
      'reportsActiveTab',
      'posSelectedLocationId',
      'transactionAdvancedFilter',
      'isFirstTimeGetCurrentRoute',
      'analyticsActiveTab',
      'cashierActiveTab',
      'locationsActiveTab',
      'dpCategoryMappingActiveTab',
      'companyUsWeek',
      'companyId',
      'selectedGroupId',
      'selectedItemGroupId',
      'sheetViewData',
      'sheetSelectedLocationId',
      'userProfileData',
      'truviewDashboardSavedInfo',
      'storeDeptDpList',
      'storeOverviewDpList',
      'storeTenderDpList',
      'terminalCashierDpList',
      'terminalDeptDpList',
      'terminalOverviewDpList',
      'terminalTenderDpList',
      'AllDataPointList',
      'truviewDashboardSavedDate',
      'truviewAllCustomUpdatedDataPointMappingIds',
      'laneListData',
      'selectedLocationIdsDoubleUp',
      'selectedLocationIdsLaneReboot',
      'selectedLocIdsDigitalReceipt'
    ];
    keysToRemove.forEach(key => localStorage.removeItem(key));
    localStorage.setItem('loggedInUser', JSON.stringify(this.switchUserData));
  }

  /*
      Function to get the required company level menu items when we switch back to the main user
      * we have made these async calls to sync calls.
  */

  async getLevels() {
    let level = null;
    level = await this.appUtils.getLevels();
    if (level) {
      await this.appUtils.getLocationHierarchy();
      await this.appUtils.getLocations();
    }
    setTimeout(() => {
      window.location.reload();
    });
  }

  getPermissions(response: any) {
    this.permissionService.getAllPermissionsData().subscribe(async (data: any) => {
      this.permissions = data.permissions;
      response['accessGroupPermissions'] = [...this.getAccessGroupPermissions(data?.access_groups)];
      this.switchUserData = response;
      this.clearLocalStorageData();
      await this.getUserProfileData();
      await this.getUserCompany();
      await this.appUtils.getLocationResponseData();
      await this.appUtils.getAllDataPointList();
      this.getLevels();
    });
  }

  getAccessGroupPermissions(accessGroupData: any) {
    let accessGroupList = [];
    if (accessGroupData.length) {
      accessGroupData.forEach((groupInfo: object) => {
        accessGroupList.push(groupInfo['name']);
      });
    }
    return accessGroupList;
  }

  switchToMainUser() {
    this.baseUtils.loading_spinner(true);
    this.sharedService.switchBack().subscribe((response) => {
      this.switchUserData = response || {};
      localStorage.setItem('loggedInUser', JSON.stringify(this.switchUserData));
      this.getPermissions(response);
    });
    localStorage.removeItem('currentRouteUrl');
  }

  getUserProfileData() {
    return new Promise((resolve) => {
      this.userProfileService.getUserProfile()
        .subscribe((response) => {
          const userData = response;
          localStorage.setItem('userProfileData', JSON.stringify(userData));
          resolve(true);
        }, (error) => {
          this.sharedService.serverErrorHandler(error);
        });
    });
  }

  getUserCompany() {
    return new Promise((resolve) => {
      this.sidenavService.getUserCompanyData()
        .subscribe((response) => {
          localStorage.setItem('companyUsWeek', response?.us_week);
          localStorage.setItem('companyId', response.id);
          localStorage.setItem('allCompanyData', JSON.stringify(response));
          resolve(true);
        }, (error) => {
          this.sharedService.serverErrorHandler(error);
        });
    });
  }

  ngOnDestroy() {
    if (this.switchUserSubscription) {
      this.switchUserSubscription.unsubscribe();
    }
    if (this.profileSubscription) {
      this.profileSubscription.unsubscribe();
    }
  }

  /**
   * To get current route
   * @param token
   */
  getCurrentRoute(token: any) {
    const permissions = token['accessGroupPermissions'];
    let role = token['role'];
    if (role === "Super Admin" || role === "Support Admin") {
      this.router.navigate(['/sales/locationItems']);
    }
    else if (permissions.length > 0) {
      switch (true) {
        case permissions.includes('Sales Access Group'):
          this.router.navigate(['/sales/locationItems'])
          break;
        case permissions.includes('Data Point Reporting Access Group'):
          this.router.navigate(['/data-point-reporting/store/overview']);
          break;
        case permissions.includes('Sheets Access Group'):
          this.router.navigate(['sheets']);
          break;
        case permissions.includes('Balancing Access Group'):
          this.router.navigate(['/balancing/dashboard']);
          break;
        case permissions.includes('POS Reports Access Group'):
          this.router.navigate(['reports']);
          break;
        case permissions.includes('Cashiers Access Group'):
          this.router.navigate(['cashiers']);
          break;
        case permissions.includes('Transactions Access Group'):
          this.router.navigate(['transactions']);
          break;
        case permissions.includes('Custom Reports Access Group'):
          this.router.navigate(['/custom-report/tax-report']);
          break;
        case permissions.includes('Analytics Access Group'):
          this.router.navigate(['/analytics/query']);
          break;
        case permissions.includes('Company Setting'):
          this.router.navigate(['/settings/companies']);
          break;
        case permissions.includes('Datapoint Setting'):
          this.router.navigate(['/settings/dp-category']);
          break;
        case permissions.includes('Location Setting'):
          this.router.navigate(['/settings/locations']);
          break;
        case permissions.includes('Users Setting'):
          this.router.navigate(['/settings/users']);
          break;
        case permissions.includes('Connector Setting'):
          this.router.navigate(['/settings/connectors']);
          break;
        case permissions.includes('Calendar Period Setting'):
          this.router.navigate(['/settings/calendar-period']);
          break;
        case permissions.includes('Instacart Setting'):
          this.router.navigate(['/settings/instacart']);
          break;
        default:
          this.baseUtils.toasterMessageAction('error', 'User does not have any permissions');
      }
    }
    localStorage.setItem('isFirstTimeGetCurrentRoute', JSON.stringify(false));
  }
}
